import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function PotatoCurry() {
  return (
    <>
      <HeaderWithSearch />
      <main style={{
        minHeight: "100vh",
        width: "100%",
        background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
        padding: 0,
        margin: 0
      }}>
        <section className="recipe-hero-anim" style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
          padding: "60px 0 20px 0"
        }}>
          <h1 className="recipe-title-anim" style={{ fontSize: "3rem", fontWeight: "bold", marginBottom: 12 }}>Potato Curry (Aloo Curry)</h1>
          <p style={{ fontSize: "1.3rem", color: "#333", marginBottom: 16 }}>A comforting, classic Indian potato curry with a rich, spiced tomato gravy.</p>
          <span className="season-badge season-winter">❄️ Best in Winter</span>
          <ImageWithFallback src="/potato-curry.jpg" alt="Potato Curry" className="recipe-image-anim" style={{ width: 340, borderRadius: 24, boxShadow: "0 4px 32px rgba(0,0,0,0.10)", marginBottom: 24, marginTop: 16 }} />
        </section>
        <section className="recipe-columns-anim" style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: 48,
          padding: "20px 0 0 0",
          maxWidth: 1200,
          margin: "0 auto"
        }}>
          <div style={{ flex: 1, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Ingredients</h2>
            <ul className="ingredient-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>2 potatoes, peeled and cubed</li>
              <li>1 tsp ginger-garlic paste</li>
              <li>1/2 tsp turmeric powder</li>
              <li>1 tsp cumin seeds</li>
              <li>1 tsp coriander powder</li>
              <li>1 tsp garam masala</li>
              <li>1/2 tsp red chili powder</li>
              <li>2 tbsp oil</li>
              <li>Salt to taste</li>
              <li>Fresh cilantro for garnish</li>
            </ul>
          </div>
          <div style={{ flex: 2, minWidth: 320 }}>
            <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 16, color: "#1a3a5d" }}>Instructions</h2>
            <ol className="instructions-list" style={{ fontSize: "1.1rem", color: "#444", lineHeight: 1.7, marginLeft: 18 }}>
              <li>Heat oil in a pan. Add cumin seeds and let them splutter.</li>
              <li>Add ginger-garlic paste and sauté for 1 minute.</li>
              <li>Add turmeric, coriander powder, red chili powder, and salt. Stir well.</li>
              <li>Add the cubed potatoes and mix to coat with the spices.</li>
              <li>Add enough water to just cover the potatoes. Cover and cook until potatoes are tender (15-20 min).</li>
              <li>Stir in garam masala and simmer for 2-3 minutes. Garnish with cilantro and serve hot with rice or roti.</li>
            </ol>
          </div>
        </section>
        <section style={{ maxWidth: 1200, margin: "0 auto", padding: "24px 24px 60px 24px", display: "flex", gap: 32, flexWrap: "wrap" }}>
          <div className="chef-tips-box" style={{ flex: 1, minWidth: 300, background: "#f8f9fa", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Cut the potatoes into even-sized cubes so they cook through at the same rate.</li>
              <li>Let the cumin seeds sizzle until fragrant before adding anything else — that builds the base flavor.</li>
              <li>Add garam masala at the end so its aroma doesn't cook off during the long simmer.</li>
              <li>For a drier, sabzi-style curry, use less water; for a soupier gravy, add more.</li>
            </ul>
          </div>
          <div className="health-benefits-box" style={{ flex: 1, minWidth: 300, background: "#eef9f0", padding: 20, borderRadius: 12 }}>
            <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
              <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
            </h3>
            <ul style={{ paddingLeft: 20 }}>
              <li>Potatoes are a good source of potassium and vitamin C, especially when cooked with the skin on.</li>
              <li>Turmeric and cumin have anti-inflammatory properties valued in traditional cooking.</li>
              <li>A light-oil version makes this a filling yet fairly low-fat comfort food.</li>
              <li>Pairing with whole-wheat roti adds fiber for a more balanced meal.</li>
            </ul>
          </div>
        </section>
      </main>
    </>
  );
}

export default PotatoCurry;
